// #region Imports
import { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import InitialiseClient from "../home/initialiseClient";
import { RequireAuth } from "./authenticatedRoute";
import { ApplicationRoutes, UnAuthenticatedRoutes } from "./config";
// #endregion

// #region Declarations
// eslint-disable-next-line @typescript-eslint/naming-convention
const HomePage = lazy(() => import("../main/homePage"));
// #endregion

// #region Component
// eslint-disable-next-line @typescript-eslint/naming-convention
export default function AppRoutes(): JSX.Element {
  return (
    <Routes>
      {UnAuthenticatedRoutes.map((route) => {
        const Component = route.component;
        return (
          <Route
            key={route.path}
            path={route.path}
            element={
              <Suspense fallback={<></>}>
                <Component />
              </Suspense>
            }
          />
        );
      })}
      <Route
        path="/"
        element={
          <RequireAuth>
            <Navigate to={ApplicationRoutes.Home} replace />
          </RequireAuth>
        }
      />
      <Route
        path="/portal/*"
        element={
          <RequireAuth>
            <Suspense fallback={<></>}>
              <HomePage />
            </Suspense>
          </RequireAuth>
        }
      />
      <Route path="*" element={<InitialiseClient />} />
    </Routes>
  );
}
// #endregion
